<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">The Process</h1>
    <p class="academics-text">
      The process of technology transfer can be summarized in 10 steps. Please
      note that these steps can vary in sequence and often occur simultaneously.
    </p>

    <div v-for="(step, i) of stepsList" :key="i">
      <v-card class="mt-4" outlined tile>
        <v-card-title class="d-block pa-4">{{ step.title }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col align="center" class="col-1" sm="1">
              <v-row>
                <v-col>
                  <div class="green--text step-text">{{ step.id }}</div>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <div>{{ step.text }}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'TheProcess',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      stepsList: [
        {
          id: 1,
          title: 'Research',
          text:
            'Observations and experiments during research activities often lead to discoveries, inventions or other outputs with potential commercial value (e.g software, research materials, etc.). Often, multiple researchers may have contributed to the invention.',
        },
        {
          id: 2,
          title: 'Pre-Disclosure',
          text:
            'An early contact with the Value Creation Office (or IRIS if you are related to FCT NOVA, or the Innovation Unit if you are related to ITQB) to discuss your invention and to provide guidance with respect to the disclosure, evaluation, and protection processes described below.',
        },
        {
          id: 3,
          title: 'Technology Disclosure',
          text:
            '(also referred to as Invention Disclosure). The written notice that begins the formal technology transfer process. The Technology Disclosure form remains a confidential document and should fully document your invention so that the options for commercialization can be evaluated and pursued.',
        },
        {
          id: 4,
          title: 'Assessment',
          text:
            'The period in which the Technology Disclosure is reviewed (with your input), patent searches are conducted (if applicable), in addition to market analysis to determine the invention’s commercialization potential. The evaluation process will guide the best strategy to commercially explore the invention, that may pass to licensing to an existing company or creating a new business start-up.',
        },
        {
          id: 5,
          title: 'Protection',
          text:
            'The process in which the best protection route is defined to maximize the social and economic impact of the invention. In case of patent protections, the process typically starts with the filing of a patent application within INPI and, when appropriate, international applications. Protection and maintenance fees may require thousands of euros, particularly if the inventions are protected internationally. Other protection options include copyright, trademark or trade secret, for example.',
        },
        {
          id: 6,
          title: 'Marketing',
          text:
            'Although this process is conducted by the University, the active involvement of inventors/authors can dramatically enhance its success. This process relates to the sourcing of potential licensees and/or candidate companies with expertise, resources and business networks to bring the technology to market, including the showcase of the technologies in national and international platforms or events.',
        },
        {
          id: 7,
          title: 'Find a licensee or Form a spin-off',
          text:
            'In cases where the invention can best be commercialized by one or more existing companies, NOVA (with your involvement) will seek potential licensees (i.e. potential commercialization partners) and work to identify mutual interests, goals and plans to fully commercialize this technology. If creation of a new business spin-off presents as the optimal commercialization path, NOVA will work, within its capabilities, to assist the founders in the company development.',
        },
        {
          id: 8,
          title: 'Licensing',
          text:
            'At this stage, a license agreement is made between NOVA and a third party, in which NOVA’s rights to a technology are licensed for financial and other benefits. This applies both to new spin-offs and established companies. NOVA Spin-offs formally recognized as such can obtain an exclusive license of an IP right developed by its promoters at no cost (apart from patent-related fees) until the commercialization stage.',
        },
        {
          id: 9,
          title: 'Commercialization',
          text:
            'The licensee company continues the advancement of the technology and makes other business investments to develop the product or service. This step may entail further development, regulatory approvals, sales and marketing, support, training, and other activities.',
        },
        {
          id: 10,
          title: 'Revenue',
          text:
            'Revenues received by NOVA from licensees are distributed to inventors, to Organics Units,  and to Research Units or research groups to support R&D and innovation activities.',
        },
      ],
    }
  },
}
</script>

<style>
.step-text {
  font-size: 17px;
  font-weight: bold;
}
</style>
